module.exports = __webpack_public_path__ + "static/media/crt.7b63a414.svg";